export default {
    namespaced: true,
    state: {
        value: false,
        color: '',
        text: ''
    },
    actions: {
        show ({ commit, state }, args) {
            if (!state.value) {
                commit('setColor', args.color)
                commit('setText', args.text)
                commit('setValue', true)
            }
        }
    },
    mutations: {
        setValue (state, value) {
            state.value = value
        },
        setColor (state, color) {
            state.color = color
        },
        setText (state, text) {
            state.text = text
        }
    }
}